import type { ViewDefinition } from '@powerportalspro/react-fluent';

// The React twin of the Blazor demo's `AdvancedFilteringViews.cs`: the Advanced Filtering demo's own
// contact views, with the same ids and the same FetchXML.

export const CONTACTS_WITH_COMPANY_CITY_VIEW_ID = '85ebabe9-c9d6-4016-abb9-184aaf9aff92';
export const CONTACTS_OF_ACTIVE_OWNERS_VIEW_ID = 'ff2e42f4-5514-463d-b783-3e2c3a467cb9';

/**
 * The contacts whose company has a city, with the city beside them: an inner join to the contact's
 * account, holding a condition of its own, which the Filter dialog shows as a related table with
 * its condition. Like All Contacts, no filter on the user: the contact table's row security keeps
 * every query to the rows the user may read.
 */
export function getContactsWithCompanyCityView(displayName: string): ViewDefinition {
  return {
    id: CONTACTS_WITH_COMPANY_CITY_VIEW_ID,
    tableName: 'contact',
    displayName,
    fetchXml: `<fetch>
      <entity name="contact">
        <attribute name="fullname" />
        <attribute name="emailaddress1" />
        <attribute name="parentcustomerid" />
        <attribute name="ppp_age" />
        <link-entity name="account" from="accountid" to="parentcustomerid" alias="company" link-type="inner">
          <attribute name="address1_city" />
          <filter>
            <condition attribute="address1_city" operator="not-null" />
          </filter>
        </link-entity>
        <order attribute="fullname" />
      </entity>
    </fetch>`,
    columns: [
      { columnName: 'fullname', width: 200 },
      { columnName: 'emailaddress1', width: 225 },
      { columnName: 'parentcustomerid', width: 200 },
      { columnName: 'company.address1_city', width: 160 },
      { columnName: 'ppp_age', width: 100 },
    ],
  };
}

/**
 * The contacts whose owner's user account is enabled: an inner join to the owner, a system
 * user, which the demo gives its visitors no access to. Their grid shows an error naming the table
 * instead of rows — taking the join away in the Filter dialog shows the rows again.
 */
export function getContactsOfActiveOwnersView(displayName: string): ViewDefinition {
  return {
    id: CONTACTS_OF_ACTIVE_OWNERS_VIEW_ID,
    tableName: 'contact',
    displayName,
    fetchXml: `<fetch>
      <entity name="contact">
        <attribute name="fullname" />
        <attribute name="emailaddress1" />
        <attribute name="parentcustomerid" />
        <attribute name="ppp_age" />
        <link-entity name="systemuser" from="systemuserid" to="owninguser" alias="owner" link-type="inner">
          <filter>
            <condition attribute="isdisabled" operator="eq" value="0" />
          </filter>
        </link-entity>
        <order attribute="fullname" />
      </entity>
    </fetch>`,
    columns: [
      { columnName: 'fullname', width: 200 },
      { columnName: 'emailaddress1', width: 225 },
      { columnName: 'parentcustomerid', width: 200 },
      { columnName: 'ppp_age', width: 100 },
    ],
  };
}
